import { ThunkResult, Utilities } from "../../shared/utilities";
import { PROCESS_TEMPLATE_BASE_URL } from "processTemplates/actions/AppActions";
import { TemplateRequestBody } from "../model/Template";
import { State } from "../model/State";
import * as FetchActions from "./FetchActions";
import * as ProcessListActions from "./ProcessListActions";

export function createTemplate(template: TemplateRequestBody): ThunkResult<void, State> {
    return async (dispatch) => {
        try {
            await Utilities.postJsonAndParseResponse(`${PROCESS_TEMPLATE_BASE_URL}/`, template);
            Utilities.toastSuccess("Template created");
            dispatch(ProcessListActions.setCreateTemplateFromProcessModal(null));
        } catch (error) {
            dispatch(FetchActions.reportFetchError(error));
        }
    };
}

export function updateTemplate(template: TemplateRequestBody): ThunkResult<void, State> {
    return async (dispatch) => {
        try {
            await Utilities.putJsonAndParseResponse(`${PROCESS_TEMPLATE_BASE_URL}/`, template);
            Utilities.toastSuccess("Template updated");
            dispatch(ProcessListActions.setCreateTemplateFromProcessModal(null));
            dispatch(FetchActions.fetchProcesses());
        } catch (error) {
            dispatch(FetchActions.reportFetchError(error));
        }
    };
}
